import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5278';

let isRefreshing = false;
let refreshPromise = null;

export const refreshAuthTokens = async () => {
  if (isRefreshing && refreshPromise) {
    return refreshPromise;
  }

  isRefreshing = true;
  refreshPromise = (async () => {
    const accessToken = localStorage.getItem('token');
    const refreshToken = localStorage.getItem('refreshToken');

    if (!accessToken || !refreshToken) {
      throw new Error('No tokens available');
    }

    const response = await axios.post(
      `${API_BASE_URL}/api/dispatcher/auth/refresh`,
      { accessToken, refreshToken }
    );

    const data = response.data;
    const newToken = data.token;
    if (!newToken) throw new Error('No token in refresh response');

    localStorage.setItem('token', newToken);
    if (data.refreshToken) {
      localStorage.setItem('refreshToken', data.refreshToken);
    }

    const payload = newToken.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
    const userData = JSON.parse(decodeURIComponent(atob(payload)));
    const existingUser = JSON.parse(localStorage.getItem('user') || '{}');
    localStorage.setItem('user', JSON.stringify({
      ...existingUser,
      ...userData,
    }));

    return newToken;
  })();

  try {
    return await refreshPromise;
  } finally {
    isRefreshing = false;
    refreshPromise = null;
  }
};

export const clearAuthAndRedirect = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('user');
  localStorage.removeItem('refreshToken');
  window.location.href = '/login';
};
